module.exports = __webpack_public_path__ + "img/bc4547e5c42688438a4037645723c7fb.png";